import { render, staticRenderFns } from "./EvalRemindButton.vue?vue&type=template&id=24a94d7c&scoped=true"
import script from "./EvalRemindButton.vue?vue&type=script&lang=js"
export * from "./EvalRemindButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a94d7c",
  null
  
)

export default component.exports